'use client';
import React, { useEffect, useState } from 'react';

import { LocalizedTime } from '../../helpers/dates';
import { OpenCloseHoursWeekdays } from './open-close-hours-weekdays.interface';

interface OpeningHoursTodayProps {
  openingHours: OpenCloseHoursWeekdays;
  openingHoursOpenToday: string;
  openingHoursClosedToday: string;
  node_locale: string;
}
export const OpeningHoursToday = ({
  openingHours,
  openingHoursOpenToday,
  openingHoursClosedToday,
  node_locale,
}: OpeningHoursTodayProps) => {
  const [todayOpeningHoursString, setTodayOpeningHoursString] =
    useState<string>();

  useEffect(() => {
    const isClosed =
      openingHours.open === 'Closed' || openingHours.close === 'Closed';

    if (isClosed) {
      setTodayOpeningHoursString(openingHoursClosedToday);
    } else {
      setTodayOpeningHoursString(
        `${openingHoursOpenToday}
        ${LocalizedTime(openingHours.open, node_locale)}
         - 
         ${LocalizedTime(openingHours.close, node_locale)}`,
      );
    }
  }, [
    setTodayOpeningHoursString,
    openingHours,
    openingHoursOpenToday,
    openingHoursClosedToday,
    node_locale,
  ]);

  return <>{todayOpeningHoursString}</>;
};
